(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__quick-add');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status && data.status === 422) return;
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var badges = document.querySelectorAll('.header__cart-count');
            badges.forEach(function(b) { b.textContent = cart.item_count; });
            if (cart.item_count > 0) {
              var cartLinks = document.querySelectorAll('.header__cart');
              cartLinks.forEach(function(link) {
                if (!link.querySelector('.header__cart-count')) {
                  var span = document.createElement('span');
                  span.className = 'header__cart-count';
                  span.textContent = cart.item_count;
                  link.appendChild(span);
                }
              });
            }
          });
        var toast = document.getElementById('cart-toast');
        if (toast) {
          toast.classList.add('cart-toast--visible');
          setTimeout(function() { toast.classList.remove('cart-toast--visible'); }, 4000);
        }
      })
      .finally(function() { btn.disabled = false; });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["widerruf-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('widerruf-modal');
    if (!modal) return;

    var dialog = modal.querySelector('.widerruf-modal__dialog');
    var lastFocused = null;

    function openModal(trigger) {
      lastFocused = trigger || document.activeElement;
      modal.hidden = false;
      /* Force a reflow so the transition runs after `hidden` is removed. */
      void modal.offsetWidth;
      modal.classList.add('widerruf-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var firstField = dialog.querySelector('textarea, input, button.btn');
      if (firstField) firstField.focus();
    }

    function closeModal() {
      modal.classList.remove('widerruf-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var onEnd = function () {
        modal.hidden = true;
        modal.removeEventListener('transitionend', onEnd);
      };
      modal.addEventListener('transitionend', onEnd);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    /* Open from any trigger anywhere on the page. */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-widerruf-open]');
      if (opener) {
        e.preventDefault();
        openModal(opener);
        return;
      }
      if (e.target.closest('[data-widerruf-close]')) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('widerruf-modal--open')) {
        closeModal();
      }
    });

    /* Basic focus trap while the dialog is open. */
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !modal.classList.contains('widerruf-modal--open')) return;
      var focusable = dialog.querySelectorAll(
        'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* After a successful submit Shopify reloads the page — re-open the modal so the
       confirmation is visible instead of silently landing back on the page. */
    if (modal.querySelector('[data-widerruf-success]')) {
      openModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
